export const HRS_TESTER_EMAIL = "test@claritygroup.com.sg";
export const HRS_CONFIGURATOR_PATH = "/sales/sandbox/hrs-rack-configurator";

export function isHrsTesterEmail(email: string | null | undefined) {
  return email?.trim().toLowerCase() === HRS_TESTER_EMAIL;
}

const HRS_TESTER_TRPC_PATHS = new Set([
  "auth.login",
  "auth.logout",
  "auth.me",
  "projectCatalogueSandbox.list",
  "projectCatalogueSandbox.aiEnrichProductQuery",
  "catalogue.searchProductImages",
  "catalogue.removeImageBackground",
  "hrsRackConfigurator.calculatePrice",
]);

export function isTrpcPathAllowedForHrsTester(path: string) {
  return HRS_TESTER_TRPC_PATHS.has(path);
}

export function isHttpPathAllowedForHrsTester(path: string) {
  return (
    path === HRS_CONFIGURATOR_PATH ||
    path.startsWith("/api/trpc/") ||
    path.startsWith("/assets/") ||
    path === "/favicon.ico" ||
    path === "/favicon.svg"
  );
}
